import { useState } from "react";
import { Trophy } from "lucide-react";
import { MiniCard } from "@/components/PlayerChip";
import { Avatar } from "@/components/Avatar";
import { useAuth } from "@/context/AuthContext";

export const MotmWinner = ({ data }) => {
  const ws = data.motm_winners || [];
  const m = data.match;
  if (!ws.length) {
    if (m.motm_tie && data.motm_tied?.length) return (
      <div data-testid="motm-tie" className="rounded-3xl p-4 bg-amber-50 border border-amber-200 text-sm">
        <p className="font-bold text-amber-700">Égalité au vote Homme du Match</p>
        <p className="text-slate-600 mt-1">{data.motm_tied.map((t) => t.short_name).join(", ")} — l'administrateur va départager.</p>
      </div>
    );
    return null;
  }
  return (
    <div data-testid="motm-winner" className="rounded-3xl p-4 bg-gradient-to-br from-amber-300 to-orange-400 text-zinc-950 shadow-lg shadow-orange-400/25 space-y-3">
      <p className="text-[11px] font-black tracking-widest text-zinc-900/70 flex items-center gap-1"><Trophy className="w-3.5 h-3.5" /> {ws.length > 1 ? "HOMMES DU MATCH" : "HOMME DU MATCH"}</p>
      {ws.map((w) => (
        <div key={w.id} className="flex items-center gap-3">
          <Avatar user={w} className="w-14 h-14 text-lg" ring="border-4 border-white" />
          <p className="font-display text-xl font-bold">{w.short_name}</p>
        </div>
      ))}
      <p className="text-xs text-zinc-900/70">{m.motm_votes} vote{m.motm_votes > 1 ? "s" : ""}</p>
    </div>
  );
};

export const MotmVote = ({ data, act }) => {
  const { user } = useAuth();
  const [sel, setSel] = useState(null);
  const [changing, setChanging] = useState(false);
  const m = data.match;
  if (!m.motm_voting_open) return null;
  const players = data.players.filter((p) => p.registration_status === "confirmed" && p.team && p.id !== user.id);
  const voted = !changing && data.my_vote && players.find((p) => p.id === data.my_vote);
  const canVote = data.me.is_participant;
  const closes = m.motm_voting_closes_at && new Date(m.motm_voting_closes_at).toLocaleString("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit", timeZone: "Indian/Mauritius" });
  return (
    <div data-testid="motm-vote" className="rounded-3xl bg-white border border-slate-200 shadow-sm p-4">
      <p className="font-display font-black text-lg text-center">QUI EST VOTRE HOMME DU MATCH ?</p>
      <p className="text-xs text-slate-500 text-center mt-1">{data.votes_total} vote{data.votes_total > 1 ? "s" : ""} enregistré{data.votes_total > 1 ? "s" : ""}{closes ? ` · clôture ${closes}` : ""}</p>
      <p className="text-[11px] text-slate-400 text-center">Résultats visibles après la clôture du vote.</p>
      {voted ? (
        <div className="mt-4 text-center">
          <p data-testid="motm-voted" className="text-sm text-cyan-700">Vous avez voté pour <b>{voted.short_name}</b>.</p>
          <button data-testid="motm-change-vote" onClick={() => { setSel(data.my_vote); setChanging(true); }} className="mt-2 text-xs text-cyan-600 underline">Modifier mon vote</button>
        </div>
      ) : !canVote ? (
        <p className="mt-4 text-center text-sm text-slate-500">Seuls les participants peuvent voter.</p>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-2 mt-4">
            {players.map((p) => (
              <div key={p.id} className="relative">
                <MiniCard p={p} testid={`motm-option-${p.id}`} selected={sel === p.id} onClick={() => setSel(p.id)} />
                {data.tally[p.id] && <span className="absolute top-1 right-1 num text-[10px] font-bold bg-amber-400 text-zinc-950 rounded-full px-1.5">{data.tally[p.id]}</span>}
              </div>
            ))}
          </div>
          <button data-testid="motm-submit-button" disabled={!sel} onClick={() => act("post", "/motm/vote", { user_id: sel }, "Vote enregistré !").then((r) => r && setChanging(false))}
            className="w-full mt-4 rounded-2xl bg-cyan-400 text-zinc-950 font-display font-black py-4 active:scale-[0.98] transition disabled:opacity-40">
            VOTER
          </button>
        </>
      )}
    </div>
  );
};
